import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { Reveal, Kicker } from "./Reveal";
import { COMPANY } from "../../data/site";

const SECTIONS = [
  {
    title: "What Are Cookies?",
    body: "Cookies are small text files stored on your device when you visit a website. They help the site function correctly, remember your preferences, and help us understand how visitors use the site.",
  },
  {
    title: "Essential Cookies",
    body: "These are required for the site to work and cannot be switched off. They include your cookie-consent choice and, if you use the admin area, your secure sign-in session. They do not store personally identifiable information beyond what is needed to operate the site.",
  },
  {
    title: "Analytics Cookies",
    body: "With your consent, we use privacy-friendly analytics to understand which pages are visited and how the site performs, so we can improve it. This data is aggregated and is not used to identify you personally. You can decline analytics using the cookie banner — the site works fully either way.",
  },
  {
    title: "Third-Party Content",
    body: "Our coverage map is provided by OpenStreetMap and our videos are hosted on our own infrastructure. Embedded third-party content may set its own cookies; we recommend reviewing the relevant third-party privacy policies.",
  },
  {
    title: "Managing Cookies",
    body: "You can change your choice at any time by clearing this site's data in your browser settings, which will show the consent banner again. You can also block or delete cookies through your browser — essential features may be affected if you block all cookies.",
  },
  {
    title: "Contact Us",
    body: `Questions about this policy? Call us on ${COMPANY.phone}, email ${COMPANY.email}, or write to ${COMPANY.office}.`,
  },
];

export const CookiesPage = () => (
  <div data-testid="cookies-page">
    <Nav />
    <section className="bg-white pb-24 pt-40 md:pt-48">
      <div className="mx-auto max-w-4xl px-6">
        <Reveal>
          <Kicker index="—" label="Legal" />
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-6 font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tight text-ink md:text-6xl">
            Cookies <span className="text-gold-shine">Policy</span>
          </h1>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-2xl leading-relaxed text-fog">
            This policy explains how {COMPANY.name} (Company No. {COMPANY.number})
            uses cookies on this website. Last updated: August 2026.
          </p>
        </Reveal>

        <div className="mt-14 border-t border-black/10">
          {SECTIONS.map((section, i) => (
            <Reveal key={section.title} delay={i * 0.05}>
              <div className="grid gap-4 border-b border-black/10 py-8 md:grid-cols-[80px_1fr]">
                <span className="font-display text-3xl font-extrabold text-outline-bronze">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h2 className="font-display text-xl font-bold uppercase tracking-wide text-ink">
                    {section.title}
                  </h2>
                  <p className="mt-3 text-sm leading-relaxed text-fog">{section.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
    <Footer />
  </div>
);
